RA.TitlePrefs = {
  loaded() {
    var $iframe = $("#titlesFrame");
    var doc = $iframe[0].contentWindow.document;
    $iframe.height(doc.body.scrollHeight);
  }
};